import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import ThreeDotsCircle from 'components/shared/Icon/icons/ThreeDotsCircle';

import ActionsMenu from '../../ActionsMenu';
import { IAction } from '../../ActionsMenu/types';
import s from './index.module.css';

interface IProps {
  actions: IAction[];
  icon?: () => JSX.Element;
  fill?: string;
  iconClassName?: string;
  actionsMenuClassName?: string;
  optionsClassName?: string;
}

function ActionsMenuCircledButton({
  actions,
  icon = ThreeDotsCircle,
  fill = '#EEEEEE',
  iconClassName,
  actionsMenuClassName,
  optionsClassName,
}: IProps) {
  return (
    <ActionsMenu actions={actions} className={actionsMenuClassName} optionsClassName={optionsClassName}>
      <Icon component={icon} fill={fill} className={cx(s.icon, iconClassName)} />
    </ActionsMenu>
  );
}

export default ActionsMenuCircledButton;
